import Api from '@/shared/services/Api'


export default 
{

	create(data) 
	{

		data.token = localStorage.getItem('token')

		return Api().post('send-create', data).catch(function (error) 
		{
	    if (error.response) 
	    {
	      console.log(error.response.data);
	      console.log(error.response.status);
	      console.log(error.response.headers);
	    } 
	    else if (error.request) 
	    {
	      console.log(error.request);
	    } 
	    else 
	    {
	      console.log('Error', error.message);
	    }

	    console.log(error.config);
	  })
	  
	},


	getByUser(id) {
		return Api().get('send-get-by-user?id='+id)
	},


	get() {
		return Api().get('send-get')
	},

	getOne(id) {
		return Api().get('send-get-one?id='+id)
	},


	getStatus(id) {
		return Api().get('send-get-status?id='+id)
	},

	getAddressByPostalCode(data) {
		return Api().post('send-get-address-by-postalcode', data)
	},

	delete(id) {
		return Api().get('send-delete?id='+id)
	},

	approvePayment(id) {
		return Api().get('send-approve-payment?id='+id)
	}

}